export default __webpack_public_path__ + "static/media/PageSizeIcon.645b9d0c.svg";